import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/solution/en_home_goldcircle.png'


const _withScopeId = n => (_pushScopeId("data-v-4ebf8c74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "committee-box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"home-title\" data-v-4ebf8c74><div class=\"title\" style=\"display:flex;align-items:center;color:#000;margin:7px 0;\" data-v-4ebf8c74><img src=\"" + _imports_0 + "\" alt=\"\" data-v-4ebf8c74><div style=\"display:flex;flex-direction:column;\" data-v-4ebf8c74><p style=\"color:rgba(0, 0, 0,1);font-size:1.5rem;margin-left:-15px;letter-spacing:2px;\" data-v-4ebf8c74>PRESS RELEASES</p></div></div></div>", 1)
const _hoisted_3 = { class: "press-content" }
const _hoisted_4 = ["item"]
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between","align-items":"baseline"} }
const _hoisted_6 = { style: {"color":"#000","font-size":"1rem","max-width":"80%","line-height":"1.7"} }
const _hoisted_7 = { style: {"color":"rgba(0, 0, 0,0.5)"} }

import Footer from "@/components/home/Footer.vue";
  import { ref, reactive } from "vue";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PressReleases',
  setup(__props) {

  const datas = reactive([
    {
      name: "Fendan Technology Closes Series B Strategic Financing to Further Its Growth in Marriage and Childbearing Sectors",
      date: "2019-8-13",
    },
    {
      name: "Fendan Technology Awarded the “Golden Rose” Most Potential Enterprise of Wedding Industry",
      date: "2018-12-9",
    },
    {
      name: "Fendan Technology Closes Series A Financing",
      date: "2017-8-7",
    }
  ]);
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            item: item
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.date), 1)
            ]),
            _createElementVNode("hr", {
              style: _normalizeStyle([{"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"}, {display: index === datas.length - 1 ? 'none' : ''}])
            }, null, 4)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})